<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery">
        <el-form-item prop="name">
          <el-input
            v-model="listQuery.name"
            placeholder="请输入字典名称"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="listQuery.code"
            placeholder="请输入字典标示"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button
          v-auth="'DictType.create'"
          class="action-item"
          type="primary"
          icon="el-icon-edit"
          @click="HandleCreate"
        >添加</el-button>
        <el-button
          v-auth="'DictType.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
        >删除</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />
      <el-table-column align="center" prop="name" label="字典名称 ">
      </el-table-column>
      <el-table-column align="center" prop="code" label="字典标示 ">
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 1" type="success">正常</el-tag>
          <el-tag v-if="scope.row.status === 2" type="danger">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间">
      </el-table-column>

      <el-table-column
        align="center"
        prop=""
        label="操作"
        width="200"
        class-name="action"
      >
        <template slot-scope="scopes">
          <el-button
            v-auth="'DictType.edit'"
            icon="el-icon-edit"
            size="mini"
            type="primary"
            @click="HandleUpdate(scopes.row)"
          >编辑</el-button>
          <el-button
            v-auth="'DictType.delete'"
            icon="el-icon-delete"
            size="mini"
            type="danger"
            @click="RowDelete(scopes.row)"
          >删除</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="110px"
        style="width: 100%;"
      >
        <el-form-item label="字典名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="字典标示" prop="code">
          <el-input v-model="temp.code" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" :label="1">正常</el-radio>
          <el-radio v-model="temp.status" :label="2">停用</el-radio>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="temp.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/system/dict_type' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor'
// import FileList from '@/components/attachment/FileList'

export default {
  name: 'DictType',
  components: {
    Pagination
    // WangEditor,
    // FileList
  },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {},
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 1,
        name: '',
        code: '',
        remark: '',
        status: 1
      }
    }
  }
}
</script>
